import React, { useContext, useState, useEffect } from 'react';
import toast from 'react-hot-toast';


import { DataContext } from '../../../init/getData';
import { PosCartContext } from '../../../init/posCartData';

import { Modal, Col, Form, Row, DropdownButton, Dropdown, InputGroup, Card } from 'react-bootstrap';
import { Space, Input, Tag, Button, Spin, Tabs, message, theme, CheckBox } from 'antd';


import { FiEdit } from "react-icons/fi";
import { FcUndo, FcRefresh, FcFlowChart, FcRules } from "react-icons/fc";
import { BiSolidTrash, BiExport } from "react-icons/bi";
import { IoBarcodeOutline } from "react-icons/io5";
import { FcKindle, FcCancel, FcPlus } from "react-icons/fc";
import { FaCheck } from "react-icons/fa";
import { HiMinusCircle } from "react-icons/hi";

import Select from 'react-select';
import AsyncSelect from 'react-select/async';
import Loader from '../../../components/loader/loader';
import MultiPriceModal from '../modals/multiPrice';
import SerialModal from '../modals/serial';

import { numberFormatter, totalFormatter, decimalFormatter } from '../../../components/formatters/numberFormatter';



const Product = (props) => {

    const { api, userData, settingData, salableData, companyId, yearId, rateFromToCurrency } = useContext(DataContext);
    const { tabData, setCart } = useContext(PosCartContext);

    const userId = userData.id;
    const userName = userData.name;
    const userRole = userData.role.name;
    const createdBy = parseInt(userData.id);

    const { refItems, selectedTab, title, selectedCategory, selectedCurrency, isDebit, idRow, type } = props;
    const [loadingEffect, setLoadingEffect] = useState(false);
    const [validated, setValidated] = useState(false);
    const [isSpinning, setIsSpinning] = useState(false);
    const [isLoading, setIsLoading] = useState(true);

    const [showProducts, setShowProducts] = useState([]);

    const [showMultiPriceModal, setShowMultiPriceModal] = useState(false);
    const [showSerialModal, setShowSerialModal] = useState(false);
    const [selectedProduct, setSelectedProduct] = useState("");
    const [serial, setSerial] = useState("");

    const cart = tabData[selectedTab].cart;

    const multiPriceModal = () => {
        setShowMultiPriceModal(!showMultiPriceModal)
    }

    const serialModal = () => {
        setShowSerialModal(!showSerialModal)
    }

    // set products by category
    useEffect(() => {
        if (selectedCategory) {
            const productData = salableData.filter((product) => product.categoryId === selectedCategory);
            setShowProducts(productData);
        }
    }, [selectedCategory]);


    const addProduct = (product) => {

        const vat = product?.vatGroup?.vat;

        let accountId;
        if (product.type == 'simple' || product.type == 'serialized') {
            accountId = settingData.salesOfGoodsAccountId;
        }
        else if (product.type == 'service') {
            accountId = settingData.salesOfServiceAccountId;
        }
        else if (product.type == 'rawMaterial') {
            accountId = settingData.salesOfRawMaterialAccountId;
        }
        else if (product.type == 'production') {
            accountId = settingData.salesOfFinishedProductsAccountId;
        }

        const productAdd = {
            accountId: accountId,
            productId: product.id,
            name: product.name,
            barcode: product.barcode,
            netQuantity: 1,
            type: product.type,
            unit: product.unit,
            unitName: product.unit,
            unitQuantity: 1,
            units: product.units,
            currency: product.currency,

            cost: rateFromToCurrency(product.currency, selectedCurrency, product.cost),
            netCost: rateFromToCurrency(product.currency, selectedCurrency, product.cost),
            totalCost: rateFromToCurrency(product.currency, selectedCurrency, product.cost),

            isStock: product.isStock,

            prices: product.prices,
            itemPrice: rateFromToCurrency(product.currency, selectedCurrency, product.price) / 1,
            price: rateFromToCurrency(product.currency, selectedCurrency, product.price),
            priceDiscountPercentage: 0,
            priceDiscountAmount: 0,
            totalPrice: rateFromToCurrency(product.currency, selectedCurrency, product.price),
            netPrice: rateFromToCurrency(product.currency, selectedCurrency, product.price),
            details: '',

            vatPercentage: vat,
            vatAmount: parseFloat(product.price * vat / 100),

        }

        setSelectedProduct(productAdd);

        if (product.type == 'serialized') {
            serialModal();
        } else {
            addProductToCart(productAdd)
        }
    };


    const addProductToCart = (productAdd) => {

        const productExists = cart.some((item) => (item.productId === productAdd.productId) && (item.unitQuantity == 1));
        let updatedCart = [...cart];

        if (productExists && productAdd.type !== 'serialized') {
            updatedCart = cart.map((item) =>
                (item.productId === productAdd.productId) && (item.unitQuantity == 1)
                    ? {
                        ...item,
                        netQuantity: parseFloat(item.netQuantity) + 1,
                        totalPrice: (item.netQuantity + 1) * item.netPrice,
                        totalCost: item.netCost * ((item.netQuantity + 1) * item.unitQuantity),
                    }
                    : item
            );
        } else {

            //if multiPrice
            if (productAdd?.prices?.length > 0) {
                setShowMultiPriceModal(true);

            } else {
                updatedCart.push(productAdd);
            }

        }

        setCart(updatedCart, selectedTab);
    };


    const scanBarcode = (e) => {
        if (e.key === "Enter") {
            const barcode = e.target.value;
            const productExists = salableData.find(product => product.barcode == barcode);
            if (productExists) {
                addProduct(productExists)
            }
            e.target.value = '';
        }
    };

    const searchProducts = (e) => {
        const search = e.toLowerCase();
        const matchingProducts = salableData.filter(product => product?.name?.toLowerCase().includes(search));
        setShowProducts(matchingProducts);
    };



    return (
        <div style={{ width: '40%', margin: 0 }}>

            <div className="card" style={{ height: '7vh' }}>

                <Row>
                    <Col md={5}>
                        <InputGroup style={{ backgroundColor: '#f0f8ff' }}>
                            <Form.Control type="text" placeholder='scan barcode..'
                                onKeyDown={e => scanBarcode(e)}
                            />
                            <InputGroup.Text><IoBarcodeOutline size={25} /></InputGroup.Text>
                        </InputGroup>
                    </Col>

                    <Col md={5}>
                        <InputGroup style={{ backgroundColor: '#f0f8ff' }}>
                            <Form.Control type="text" placeholder='search products..'
                                onChange={e => searchProducts(e.target.value)}
                            />
                            <InputGroup.Text><IoBarcodeOutline size={25} /></InputGroup.Text>
                        </InputGroup>
                    </Col>
                    <Col md={1}>
                        <FcRefresh onClick={refItems} style={{ cursor: 'pointer' }} size={35} />
                    </Col>
                </Row>

            </div>


            <div
                className="card custom-scrollbar"
                style={{
                    height: '93vh',
                    overflowY: 'auto',
                    overflowX: 'hidden',
                    display: 'grid',  // Use CSS Grid
                    gridTemplateColumns: 'repeat(4, 1fr)', // 4 equal-width columns
                    gridAutoRows: 'minmax(80px, 80px)', // Ensures rows adjust based on content, but stay at least 150px tall
                    gap: '5px',  // Space between items (adjust as needed)
                }}
            >
                {showProducts?.map((product, index) => (
  <div
    className="card"
    key={index}
    onClick={() => addProduct(product)}
    style={{
      height: '80px',
      width: '95%',
      marginTop: 5,
      padding: '10px',
      display: 'flex',
      justifyContent: 'center', // Horizontally center text
      alignItems: 'center', // Vertically center text
      backgroundColor: '#b7e3f2',
      cursor: 'pointer',
      fontWeight: '500',
      boxSizing: 'border-box',
      overflow: 'hidden',
      textAlign: 'center', // Ensure text is centered inside
    }}
    title={product?.name}
  >
    <div
      style={{
        display: '-webkit-box',
        WebkitLineClamp: 3,
        WebkitBoxOrient: 'vertical',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'normal',
        lineHeight: '1.2em',
        maxHeight: '3.6em', // Keeps 3-line limit
        width: '100%',
        textAlign: 'center', // Ensures all text is center-aligned
      }}
    >
      {product?.name}
    </div>
  </div>
))}

            </div>

            {showMultiPriceModal &&
                <MultiPriceModal
                    showModal={showMultiPriceModal}
                    toggleModal={multiPriceModal}
                    idRow={idRow}
                    title={'Select Price'}
                    selectedTab={selectedTab}
                    selectedProduct={selectedProduct}
                    addProductToCart={addProductToCart}
                />
            }

            {showSerialModal &&
                <SerialModal
                    showModal={showSerialModal}
                    toggleModal={serialModal}
                    setSerial={setSerial}
                    serial={serial}
                    selectedProduct={selectedProduct}
                    addProductToCart={addProductToCart}
                />
            }

        </div>



    )
}


export default Product;